import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component } from '@angular/core';
import { MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatProgressBar } from '@angular/material/progress-bar';

import { DialogHeaderComponent } from 'src/app/shared/components/dialog-header/dialog-header.component';
import { InlineNotificationComponent } from "src/app/shared/components/inline-notification/inline-notification/inline-notification.component";
import { AppsService } from '../../../../../services';
import { AppAliasService, BulkSiteUploadShapefileLogicService } from '../../../../../services/logic-services';

@Component({
    selector: 'kh-bulk-site-upload-shapefile-save-sites-dialog',
    templateUrl: './bulk-site-upload-shapefile-save-sites-dialog.component.html',
    styleUrls: ['./bulk-site-upload-shapefile-save-sites-dialog.component.scss'],
    imports: [
        CdkScrollable,
        DialogHeaderComponent,
        InlineNotificationComponent,
        MatDialogContent,
        MatDialogTitle,
        MatProgressBar,
    ]
})
export class BulkSiteUploadShapefileSaveSitesDialogComponent {

    get percentComplete(): number {
        return this._bulkSiteUploadShapefileLogicService.model.saveSitesStep.percentComplete;
    }

    get sitesAliasLowerCase(): string {
        return this._appAliasService.sitesAliasLowerCase;
    }

    get siteAlias(): string {
        return this._appsService.currentApp.aliases.site.singular;
    }

    constructor(
        private _appAliasService: AppAliasService,
        private _appsService: AppsService,
        private _bulkSiteUploadShapefileLogicService: BulkSiteUploadShapefileLogicService
    ) { }
}
